module.exports = __webpack_public_path__ + "static/media/plan-wom-150-gigas.575ab1cf.svg";